export enum COURSE_STYLE_TABS_KEYS {
  GLOBAL = 'GLOBAL',
  STYLE = 'STYLE'
}
